var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.time)?_c('span',[_vm._v(" อายุรหัส "+_vm._s(_vm.time)+" นาที ")]):_c('span',[_vm._v(" OTP หมดอายุ ")])}
var staticRenderFns = []

export { render, staticRenderFns }